import { useTranslation } from "react-i18next";
import { DiffStatusChip } from "../../DiffStatusChip";
import { TYPE_LABEL_KEY } from "../constants";
import type { QuantityDiffStatus } from "../../utils/computeQuantityDiff";
import type { QuantityStatusFilterProps } from "./types";

const FILTERABLE_STATUSES: QuantityDiffStatus[] = [
  "added",
  "removed",
  "changed",
  "unchanged",
];

export const QuantityStatusFilter = ({
  entryCountByStatus,
  totalEntryCount,
  kind,
  value,
  onChange,
}: QuantityStatusFilterProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="whitespace-nowrap text-xs font-medium text-gray-500">
        {t(TYPE_LABEL_KEY[kind])}
      </span>
      <DiffStatusChip
        label={t("smartSurveyor.planComparison.quantities.all")}
        count={totalEntryCount}
        isSelected={value === "all"}
        onSelect={() => onChange("all")}
      />
      {FILTERABLE_STATUSES.map((status) => (
        <DiffStatusChip
          key={status}
          label={t(`smartSurveyor.planComparison.quantities.${status}`)}
          count={entryCountByStatus[status]}
          status={status}
          isSelected={value === status}
          onSelect={() => onChange(status)}
        />
      ))}
    </div>
  );
};
